import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './HomeOwnerWorldTeaser.less';
import tracking from '../../tracking/tracking.js';
import { CLAIM_PROPERTY } from '../../tracking/trackingNaming.js';

export default class HomeOwnerWorldTeaser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      componentClosed: false,
    };
  }

  handleButtonClick = () => {
    tracking.overwriteTrackingEventContext('overview');
    tracking.report(CLAIM_PROPERTY);
    tracking.revertTrackingEventContext();
    this.props.onButtonClicked();
  };

  render() {
    const displayStyle = { visibility: !this.state.componentClosed ? 'visible' : 'hidden' };

    return (
      <div
        data-identifier="my-property-widget"
        className={`grid-item grid-flex margin-top-xl ${styles.myPropertyContainer}`}
        style={displayStyle}
      >
        <div className={`${styles.myPropertyCloseIconContainer}`} />
        <div className="grid-item three-fourths palm-one-whole">
          <div className={styles.titleContainer}>
            <div className="indicator indicator--brand" role="presentation">
              <span>NEU</span>
            </div>
            <span className={`align-middle ${styles.headline}`}>Für Eigentümer</span>
          </div>
          <span className="font-normal">Nachfrage prüfen, Markt beobachten und Preisupdates erhalten.</span>
        </div>
        <div className={`grid-item one-fourth align-center palm-one-whole ${styles.myPropertyButton} grid-align-end`}>
          <button
            id="my-property-widget-button"
            type="button"
            className="button-primary"
            onClick={this.handleButtonClick}
          >
            Jetzt starten
          </button>
        </div>
      </div>
    );
  }
}

HomeOwnerWorldTeaser.propTypes = {
  onButtonClicked: PropTypes.func.isRequired,
};
